export const LayerType = {
    STATION: 1, // 站台
    ROOF_SLAB: 2, // 屋面板
    COLUMN: 3, // 柱
    EAVES_BOARD: 4, // 檐口板
    GUTTER: 5, // 天沟

    ANEMOCLINOGRAPH: 11, // 风速风向仪
    FLUVIOGRAPH: 12, // 水位计
    CAMERA: 13, // 摄像头

    SERIAL: 21, // 串口设备
    DVR: 22, // 硬盘录像机
    IPC: 23, // 工控机
    CABLE: 31, // 数据线缆

    TREE: 41, // 乔灌木
    STREET_LAMP: 42, // 路灯
    COMPASS: 43 // 指北针

    
}

export const LayerTypeList = [
    { value: 1, label: '站台' },
    { value: 2, label: '屋面板' },
    { value: 3, label: '柱' },
    { value: 4, label: '檐口板' },
    { value: 5, label: '天沟' },

    { value: 11, label: '风速风向仪' },
    { value: 12, label: '水位计' },
    { value: 13, label: '摄像头' },

    { value: 21, label: '串口设备' },
    { value: 22, label: '硬盘录像机' },
    { value: 23, label: '工控机' },

    { value: 31, label: '数据线缆' },

    { value: 41, label: "乔灌木" },
    { value: 42, label: "路灯" },
    { value: 43, label: "指北针" },
]

export function getLayerTypeName(layerType: number) {
    let label = LayerTypeList.find(item => item.value === layerType)?.label || null;
    return label
}